import React from "react";
import "react-tippy/dist/tippy.css";
import { Tooltip, withTooltip } from "react-tippy";


const EasyTippy = ({ text, children }) => (
  <Tooltip
    position="bottom"
    trigger="mouseenter focus"
    distance={10}
    hideDelay={0}
    size="small"
    html={
      <div className="grommet">
        <span>{text}</span>
      </div>
    }
    animateFill={true}
  >
    {children}
  </Tooltip>
);

export default Tooltip;
export { withTooltip, EasyTippy };
